import React from 'react';
import { BulkUploadHelperText, DraftCard, DraftCardBody, DraftOverviewBody, DraftStartButton } from '../styles';

export const PendingBatchRecoveryState = ({ isError = false, onRetry }) => (
  <DraftOverviewBody role={isError ? 'alert' : 'status'}>
    <DraftCard>
      <DraftCardBody>
        <BulkUploadHelperText>
          {isError
            ? 'Your saved upload could not be resumed. Try again to check its progress.'
            : 'Your upload is still saving. This page will resume automatically.'}
        </BulkUploadHelperText>
        {isError && <DraftStartButton type="button" onClick={onRetry}>Try again</DraftStartButton>}
      </DraftCardBody>
    </DraftCard>
  </DraftOverviewBody>
);
